<template>
  <div>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      persistent
      width="800px"
    >
      <v-card v-if="dialog">
        
        <v-card-title primary-title>
          <v-tabs v-model="tab">
            <v-tab :href="'#asociar'" v-if="isEditing && !isAsociado">Asociar daño</v-tab>
            <v-tab :href="'#asociados'">Daños asociados</v-tab>
          </v-tabs>
        </v-card-title>

        <v-card-text>
          <v-expand-transition>
            <v-row align="center" justify="space-around" v-if="invalid && isAsociar">
              <v-col cols="12" class="error--text">
                {{ selectedErrors[0] }}
              </v-col>
            </v-row>
          </v-expand-transition>
          <v-row align="center" justify="space-around">
            <v-col cols="12">
              <v-tabs-items v-model="tab" touchless>

                <v-tab-item :value="'asociar'">
                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="bladeDamages"
                    :items-per-page="5"
                    show-select
                  ></v-data-table>
                </v-tab-item>

                <v-tab-item :value="'asociados'">

                  <div v-if="isAsociado">
                    <v-alert text type="error">
                      Este daño es asociado de:
                    </v-alert>
                  </div>

                  <v-data-table
                    :headers="filteredHeaders"
                    :items="items"
                    :items-per-page="5"
                  >
                    <!-- Action -->
                    <template v-slot:item.action="{ item }">
                      <v-icon @click="show('delete', item)">mdi-delete</v-icon>
                    </template>
                  </v-data-table>

                </v-tab-item>

              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Buttons -->
        <v-card-actions>
          <v-spacer/>
          <span v-if="isEditing && isAsociar && !isAsociado">
            <v-btn text class="mr-4" @click="close()">Cancelar</v-btn>
            <v-btn color="primary" class="white--text" :disabled="invalid || !bladeDamages.length" @click="save()">Asociar</v-btn>
          </span>
          <v-btn color="primary" @click="close()" v-else>Cerrar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Confirmation -->
    <confirmation
      v-model="deleteDialog"
      title="Eliminar daño asociado"
      text="Desea eliminar el daño asociado"
      @close="close('delete')"
      @confirm="deleteItem()"
    />

  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Confirmation from "@/components/Confirmation";
import Util from "@/util/index";

export default {
  name: 'ref-damage',
  props: {
    value: Boolean,
    isEditing: { type: Boolean, default: false },
    item: { type: Object, default: () => {} },
  },
  mixins: [validationMixin],
  validations: {
    selected: { required },
  },
  components: {
    Confirmation
  },
  data: () => ({
    tab: 'asociar',
    dialog: false,
    deleteDialog: false,
    itemSelected: {},
    selected: [],
    headers: [
      { text: "Intervención", value: "work_intervention_id", align: "center" },
      { text: "AG", value: "wind_turbine", align: "center" },
      { text: "Posición", value: "location", align: "center" },
      { text: "Código del daño", value: "blade_damage_type.name", align: "center" },
      { text: "Grado", value: "severity", align: "center" },
    ],
  }),
  watch: {
    value (val) {
      this.dialog = val
      this.tab = this.isEditing && !this.isAsociado ? 'asociar' : 'asociados'
    },
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isAsociar () {
      return this.tab === 'asociar'
    },
    invalid () {
      return this.$v.$dirty && this.$v.$invalid
    },
    filteredHeaders () {
      const headers = JSON.parse(JSON.stringify(this.headers))
      headers.push({ text: "Acción", value: "action", sortable: false, align: "center" })
      return headers.filter(element => this.isEditing && element.value === 'action' || element.value !== 'action')
    },
    isAsociado () {
      const damages = this.$store.state.interventions.bladeDamageSimilars.list.filter(element => element.similar_blade_damage_id === this.item.id)
      return !!damages.length
    },
    bladeDamageSimilars () {
      return this.$store.state.interventions.bladeDamageSimilars.list
        .filter(element => {
          return element.blade_damage_id === this.item.id
            || element.similar_blade_damage_id === this.item.id
        })
    },
    bladeDamages () {
      const blade_damage_id = this.bladeDamageSimilars.map(element => element.blade_damage_id)
      const similar_blade_damage_id = this.bladeDamageSimilars.map(element => element.similar_blade_damage_id)
      return this.$store.state.interventions.bladeDamageSimilars.damages
        .filter(element => {
          console.log("bladeDamages -> blade_damage_id", blade_damage_id)
          console.info(blade_damage_id.includes(element.id));
          console.log("bladeDamages -> similar_blade_damage_id", similar_blade_damage_id)
          console.info(similar_blade_damage_id.includes(element.id));
          return element.work_intervention_id != this.$route.params.id
            && element.wind_turbine == this.item.wind_turbine
            && !blade_damage_id.includes(element.id)
            && !similar_blade_damage_id.includes(element.id)
        })
    },
    items() {
      return this.bladeDamageSimilars.map(element => {
        const damage = element.similar_blade_damage_id === this.item.id ? element.damage: element.similar_damage
        let obj = {
          ...damage
        }
        obj.id = element.id
        return obj
      })
    },
    selectedErrors () {
      const errors = []
      if (!this.$v.selected.$dirty) return errors
      !this.$v.selected.required && errors.push('Debes seleccionar un daño.')
      return errors
    },
  },
  methods: {
    show(dialog, item) {
      if (item) this.itemSelected = item
      if (dialog === 'delete') this.deleteDialog = true
    },
    close (dialog) {
      if (dialog === 'delete') {
        this.deleteDialog = false
        this.itemSelected = {}
      }
      else {
        this.dialog = false
        this.selected = []
        this.$emit('close')
        this.$v.$reset()
      }
    },
    async save () {
      // const action = this.isNew ? 'create' : 'edit'
      const action = 'create'
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let error = null
        for (let i=0; i < this.selected.length; i++) {
          const body = {
            work_intervention_id: this.item.work_intervention_id,
            blade_damage_id: this.item.id,
            similar_blade_damage_id: this.selected[i].id
          }
          await this.$store.dispatch(`interventions/bladeDamageSimilars/${action}`, body)
            .catch(err => {
              error = err
            })
        }
        if (!error) {
          this.$toast("Daños asociados correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.$emit('init')
          this.tab = 'asociados'
        } else {
          var errorToastMessage = "Ha ocurrido un error asociando los daños."
          Util.showErrorToast(this, error, errorToastMessage);
        }
        this.selected = []
        this.$v.$reset()
        this.loading = false
      }
    },
    deleteItem() {
      this.loading = true
      const body = {
        work_order_id: this.$route.params.work_order,
        id: this.itemSelected.id
      }
      this.close('delete')
      this.$store.dispatch(`interventions/bladeDamageSimilars/delete`, body)
        .then(() => {
          this.$toast("Daño elimnado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.$emit('init')
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error eliminando el daño asociado."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
}
</script>
